<span aria-hidden="true"
{{!-- will be removed, this is for tab legacy icons --}}
{{#if iconTab}}
  {{#if index}}
    data-icon="{{uuid}}-{{index}}-{{prefix}} {{name}}"
    {{else}}
      data-icon="{{uuid}}-{{prefix}} {{name}}"
  {{/if}}
{{/if}}
{{!-- *** --}}
  {{#if icon}}
    {{#if index}}
      data-icon="{{uuid}}-{{index}}-{{icon}}"
    {{else}}
      data-icon="{{uuid}}-{{icon}}"
    {{/if}}
  {{else}}
  {{#if layer_icons}}
    id={{uuid}}
  {{else}}
    {{#if index}}
      data-icon="{{uuid}}-{{index}}-{{prefix}} {{name}}"
      {{else}}
        data-icon="{{uuid}}-{{prefix}} {{name}}" 
    {{/if}}
  {{/if}}
 {{/if}}
  class="{{classes}}" 
  {{#if sr_caption}} 
    title="{{sr_caption}}" 
  {{/if}}>
  {{#if sr_caption}}<span class="screen-reader-content">{{t sr_caption}}</span>{{/if}}
</span>
